import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';
import {useEffect, useState} from "react";
import {mongoIdToColor} from "../utils/utils";

const Triggers = ({selectedManager}) => {
	const [timespan, setTimespan] = useState(1);
	const [data, setData] = useState([]);
	const [alerts, setAlerts] = useState([]);

	useEffect(() => {
		if(!selectedManager) {
			setAlerts([]);
			setData([]);
			return;
		}
		window.reqServer("/alert/data/triggers", "get", {id:selectedManager, timespan}, (data) => {
			const formedData = data.labels.map((label, i)=>{
				const point = { date: new Date(label) };
				data.data.forEach((elem)=>{
					point[elem.id] = elem.values[i];
				})
				return point;
			})
			setData(formedData);
			setAlerts(data.data.map((elem)=>({id: elem.id, name: elem.name})))
		})
	}, [selectedManager, timespan]);

	return <div style={{width: "60%"}}>
		<div className="select-dropdown">
			<select value={timespan} onChange={(e)=>setTimespan(Number(e.target.value))}>
				<option value={0}>Week</option>
				<option value={1}>Month</option>
				<option value={2}>3 Months</option>
			</select>
		</div>
		<ResponsiveContainer width="100%" height={300}>
			{alerts.length > 0
				? 			<LineChart data={data}>
					<CartesianGrid strokeDasharray="3 3" />
					<Legend verticalAlign="top" height={36}/>
					<XAxis
						dataKey="date"
						domain={['auto', 'auto']}
						name="Date"
						tickFormatter={timeStr => new Date(timeStr).toLocaleDateString()}
						type="number"
						scale="time"
					/>
					<YAxis />
					<Tooltip labelFormatter={label => new Date(label).toLocaleString()} />
					{
						alerts.map((alert)=><Line
							name={alert.name} type="monotone" dataKey={alert.id} stroke={mongoIdToColor(alert.id)} dot={false}
							strokeWidth={3} key={alert.id}
						/>)
					}
				</LineChart>
				: <h1>No data to show...</h1>
			}
		</ResponsiveContainer>
	</div>
}
export default Triggers;